// Copyright 2021 NewSocial Inc. - All Rights Reserved
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential
// Author(s): See Git History

const Notifications: React.FC<any> = () => <div>Notifications</div>;
export default Notifications;
